import { render, staticRenderFns } from "./ExpenseAdd.vue?vue&type=template&id=02153160&"
import script from "./ExpenseAdd.vue?vue&type=script&lang=js&"
export * from "./ExpenseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports